import { render, staticRenderFns } from "./ScoringStatus.vue?vue&type=template&id=8722d1bc&"
import script from "./ScoringStatus.vue?vue&type=script&lang=js&"
export * from "./ScoringStatus.vue?vue&type=script&lang=js&"
import style0 from "./ScoringStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports